import { currentCountry } from '@/common/const';
import { useFirstScreenAB } from '@/hooks/abTest/firstScreen/useFirstScreenAb';
import { useFirstScreenKconf } from '@/hooks/abTest/firstScreen/useFirstScreenKconf';

export function useABHandler() {
    const state = useFirstScreenAB();
    return { detailABValueMap: state };
}

export function useInstallmentFirstThresholdValue() {
    const state = useFirstScreenKconf();
    const kconfKey = 'overseaServer.ecommerceContent.productInstallmentHighValueLimit';
    const thresholdValue = state.loading ? null : state[kconfKey]?.[currentCountry] || Number.MAX_SAFE_INTEGER;

    console.log('thresholdValue', thresholdValue);
    return {
        thresholdValue,
    };
}
